<div class="suggestion-container">
    <div class="form-container" [formGroup]="suggestionForm">
        <textarea-extended-control controlName="suggestionText" iconClass="fas fa-lightbulb" cols="18" rows="10" placeholderText="suggestion.placeholder" labelText="suggestion.suggestion" [parentFormHelper]="suggestionForm"></textarea-extended-control>
        <div class="col-md-6 d-flex flex-column justify-content-end">
            <div class="flex-grow-1"></div>
            <div>
                <button-control buttonType="button" themeColor="info" buttonClass="w-100" [buttonText]="'common.save'" [onClickAsync]="saveSuggestion"> </button-control>
            </div>
        </div>
    </div>
</div>
